(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('RegionDialogController', RegionDialogController);

    RegionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Region', 'Province', 'Country', 'moment'];

    function RegionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Region, Province, Country, moment) {
        var vm = this;
        vm.region = entity;
        vm.clear = clear;
        vm.save = save;
        vm.provinces = Province.query();
        vm.countries = Country.query();
        vm.timeZones = moment.tz.names().filter(function(zoneId) {
            return zoneId.startsWith("Canada/");
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.$on('$stateChangeStart', function() {
            $uibModalInstance.dismiss('stateChange');
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.region.id !== null) {
                Region.update(vm.region, onSaveSuccess, onSaveError);
            } else {
                Region.save(vm.region, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:regionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
